import React from "react";
import { useGetEngageAudiencesQuery } from "../../api/engageApi";
import {
  ACTIVITY_OPTIONS,
  DEFAULT_FEED_FILTERS,
  SORT_OPTIONS,
  audienceSections,
  hasActiveFilters,
} from "./constants";

const SELECT_CLASS =
  "rounded-md border border-gray-300 bg-white px-2.5 py-1.5 text-sm text-gray-700";

const LABEL_CLASS =
  "text-[10px] font-semibold uppercase tracking-wider text-gray-400";

// All three values go to the server as query params - nothing is filtered in
// React, or paging would report counts for a page it did not actually return.
const EngageFilters = ({ filters, onChange, disabled }) => {
  const { data: audiences } = useGetEngageAudiencesQuery();
  const sections = audienceSections(audiences);
  const dirty = hasActiveFilters(filters);

  const set = (key) => (event) =>
    onChange({ ...filters, [key]: event.target.value });

  return (
    <div className="mb-4 flex flex-wrap items-end gap-4 rounded-lg border border-gray-200 bg-white px-4 py-3">
      <div className="flex flex-col gap-1">
        <label className={LABEL_CLASS} htmlFor="engage-activity">
          Activity
        </label>
        <select
          id="engage-activity"
          className={SELECT_CLASS}
          value={filters.activity}
          onChange={set("activity")}
          disabled={disabled}
        >
          {ACTIVITY_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-col gap-1">
        <label className={LABEL_CLASS} htmlFor="engage-group">
          Group
        </label>
        <select
          id="engage-group"
          className={SELECT_CLASS}
          value={filters.audienceId}
          onChange={set("audienceId")}
          disabled={disabled}
        >
          <option value="">All groups</option>
          {sections.map((section) => (
            <optgroup key={section.key} label={section.label}>
              {section.rows.map((row) => (
                <option key={row.id} value={row.id}>
                  {row.name}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>

      <div className="ml-auto flex items-end gap-3">
        {dirty && (
          <button
            type="button"
            onClick={() => onChange({ ...DEFAULT_FEED_FILTERS })}
            className="pb-1.5 text-xs font-semibold text-blue-600 underline hover:text-blue-700"
          >
            Clear filters
          </button>
        )}

        <div className="flex flex-col gap-1">
          <label className={LABEL_CLASS} htmlFor="engage-sort">
            Sort
          </label>
          <select
            id="engage-sort"
            className={SELECT_CLASS}
            value={filters.sort}
            onChange={set("sort")}
            disabled={disabled}
          >
            {SORT_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default EngageFilters;
